import { render, staticRenderFns } from "./ExpertView.vue?vue&type=template&id=5f1d6016&"
import script from "./ExpertView.vue?vue&type=script&lang=js&"
export * from "./ExpertView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports